import { List } from "immutable";
const buildSpCredentials = (values) => {
  var _a;
  if (values.spCredentialCertificate && values.spCredentialPrivateKey) {
    return [
      {
        // is_set is the value we get from the API. If that didn't change, we need to send keep_value. Otherwise,
        // we set a new value.
        private_key: ((_a = values.spCredentialPrivateKey) == null ? void 0 : _a.is_set) ? { keep_value: true } : values.spCredentialPrivateKey,
        certificate: values.spCredentialCertificate
      }
    ];
  }
  return [];
};
export const toConfigJSON = (values) => ({
  type: values.type,
  // Set empty URL values as undefined to avoid sending empty strings to the backend.
  idp_metadata_url: values.idpMetadataUrl || void 0,
  idp_metadata_refresh: values.idpMetadataRefreshAtLogin ? "at_login" : "disabled",
  idp_sso_service_redirect_binding_url: values.idpSsoServiceRedirectBindingUrl || void 0,
  idp_sso_service_post_binding_url: values.idpSsoServicePostBindingUrl || void 0,
  idp_logout_service_redirect_binding_url: values.idpLogoutServiceRedirectBindingUrl || void 0,
  idp_logout_service_post_binding_url: values.idpLogoutServicePostBindingUrl || void 0,
  idp_entity_id: values.idpEntityId,
  // The backend already supports multiple IdP certificates, the UI only one for now.
  idp_certificates: values.idpCertificate ? [values.idpCertificate] : [],
  // Set empty attribute values as undefined to avoid sending empty strings to the backend.
  idp_user_name_attribute: values.idpUserNameAttribute || void 0,
  idp_email_attribute: values.idpEmailAttribute || void 0,
  idp_first_name_attribute: values.idpFirstNameAttribute || void 0,
  idp_last_name_attribute: values.idpLastNameAttribute || void 0,
  idp_full_name_attribute: values.idpFullNameAttribute || void 0,
  sp_base_url: values.spBaseUrl || void 0,
  sp_entity_id: values.spEntityId,
  sp_credentials: buildSpCredentials(values)
});
export const fromAuthenticationBackend = (backend, teamSyncBackend) => {
  var _a, _b;
  const config = backend.config;
  if (teamSyncBackend == null ? void 0 : teamSyncBackend.config) {
    config.teamSyncIsCurrentlyEnabled = true;
    config.teamSyncEnabled = true;
    config.teamSyncGroupAttributeName = (_a = teamSyncBackend.config) == null ? void 0 : _a.group_attribute_name;
    config.teamSyncAllowedGroups = (_b = teamSyncBackend.config) == null ? void 0 : _b.allowed_groups.join(",");
  } else {
    config.teamSyncIsCurrentlyEnabled = false;
    config.teamSyncEnabled = false;
    config.teamSyncAllowedGroups = void 0;
  }
  return {
    id: backend.id,
    title: backend.title,
    description: backend.description,
    defaultRoles: backend.defaultRoles.join(","),
    defaultUserTimezone: backend.defaultUserTimezone,
    ...config
  };
};
export const fromConfigJSON = (payload) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  return {
    type: payload.type,
    idpMetadataUrl: payload.idp_metadata_url,
    idpMetadataRefreshAtLogin: payload.idp_metadata_refresh === "at_login",
    idpSsoServiceRedirectBindingUrl: payload.idp_sso_service_redirect_binding_url,
    idpSsoServicePostBindingUrl: payload.idp_sso_service_post_binding_url,
    idpLogoutServiceRedirectBindingUrl: payload.idp_logout_service_redirect_binding_url,
    idpLogoutServicePostBindingUrl: payload.idp_logout_service_post_binding_url,
    idpEntityId: payload.idp_entity_id,
    // The backend already supports multiple IdP certificates, the UI only one for now.
    idpCertificate: (_a = payload.idp_certificates) == null ? void 0 : _a[0],
    idpCertificateFilename: ((_b = payload.idp_certificates) == null ? void 0 : _b[0]) && "idp-certificate.pem",
    idpCertificateInfo: void 0,
    idpCertificateInfoError: void 0,
    idpUserNameAttribute: payload.idp_user_name_attribute,
    idpEmailAttribute: payload.idp_email_attribute,
    idpFirstNameAttribute: payload.idp_first_name_attribute,
    idpLastNameAttribute: payload.idp_last_name_attribute,
    idpFullNameAttribute: payload.idp_full_name_attribute,
    spBaseUrl: payload.sp_base_url,
    spEntityId: payload.sp_entity_id,
    // The backend already supports multiple SP credentials, the UI only one for now.
    spCredentialCertificate: (_d = (_c = payload.sp_credentials) == null ? void 0 : _c[0]) == null ? void 0 : _d.certificate,
    spCredentialCertificateFilename: ((_e = payload.sp_credentials) == null ? void 0 : _e[0].certificate) && "sp-certificate.pem",
    spCredentialCertificateInfo: void 0,
    spCredentialCertificateInfoError: void 0,
    spCredentialPrivateKey: (_g = (_f = payload.sp_credentials) == null ? void 0 : _f[0]) == null ? void 0 : _g.private_key,
    spCredentialPrivateKeyFilename: ((_i = (_h = payload.sp_credentials) == null ? void 0 : _h[0]) == null ? void 0 : _i.private_key.is_set) && "sp-private-key.pem",
    teamSyncIsCurrentlyEnabled: false,
    teamSyncEnabled: false,
    teamSyncGroupAttributeName: void 0,
    teamSyncAllowedGroups: void 0
  };
};
export const toBackendJSON = (values) => ({
  id: values.id,
  title: values.title,
  description: values.description,
  default_roles: List(values.defaultRoles.split(",")),
  default_user_timezone: values.defaultUserTimezone,
  config: toConfigJSON(values)
});
